import { Colors } from './Colors.js';

import one01 from './samples/SP_1/DOL_Texture_A_Loop.mp3'; // TODO: check how dynamically import samples
import one02 from './samples/SP_1/DOL_Texture_A1_Loop.mp3';
import one03 from './samples/SP_1/DOL_Texture_E_Loop.mp3';
import one04 from './samples/SP_1/DOL_Texture_H1_Loop.mp3';
import one05 from './samples/SP_1/DOL_Texture_K_Loop.mp3';
import one06 from './samples/SP_1/DOL_Texture_M1_Loop.mp3';
import one07 from './samples/SP_1/DOL_Texture_O_Loop.mp3';
import one08 from './samples/SP_1/DOL_Texture_S_Loop.mp3';

import two01 from './samples/SP_2/DOL_Texture_B_Loop.mp3'; // TODO: check how dynamically import samples
import two02 from './samples/SP_2/DOL_Texture_C_Loop.mp3';
import two03 from './samples/SP_2/DOL_Texture_C1_Loop.mp3';
import two04 from './samples/SP_2/DOL_Texture_G1_Loop.mp3';
import two05 from './samples/SP_2/DOL_Texture_J1_Loop.mp3';
import two06 from './samples/SP_2/DOL_Texture_L1_Loop.mp3';
import two07 from './samples/SP_2/DOL_Texture_Q_Loop.mp3';
import two08 from './samples/SP_2/DOL_Texture_W_Loop.mp3';

import three01 from './samples/SP_3/DOL_Texture_B1_Loop.mp3'; // TODO: check how dynamically import samples
import three02 from './samples/SP_3/DOL_Texture_D_Loop.mp3';
import three03 from './samples/SP_3/DOL_Texture_F_Loop.mp3';
import three04 from './samples/SP_3/DOL_Texture_I1_Loop.mp3';
import three05 from './samples/SP_3/DOL_Texture_K1_Loop.mp3';
import three06 from './samples/SP_3/DOL_Texture_L_Loop.mp3';
import three07 from './samples/SP_3/DOL_Texture_R_Loop.mp3';
import three08 from './samples/SP_3/DOL_Texture_X_Loop.mp3';

import four01 from './samples/SP_4/DOL_Texture_E1_Loop.mp3'; // TODO: check how dynamically import samples
import four02 from './samples/SP_4/DOL_Texture_F1_Loop.mp3';
import four03 from './samples/SP_4/DOL_Texture_J1_Loop.mp3';
import four04 from './samples/SP_4/DOL_Texture_N_Loop.mp3';
import four05 from './samples/SP_4/DOL_Texture_P_Loop.mp3';
import four06 from './samples/SP_4/DOL_Texture_T_Loop.mp3';
import four07 from './samples/SP_4/DOL_Texture_U_Loop.mp3';
import four08 from './samples/SP_4/DOL_Texture_Y_Loop.mp3';

import five01 from './samples/SP_5/DOL_Texture_D1_Loop.mp3'; // TODO: check how dynamically import samples
import five02 from './samples/SP_5/DOL_Texture_G1_Loop.mp3';
import five03 from './samples/SP_5/DOL_Texture_H_Loop.mp3';
import five04 from './samples/SP_5/DOL_Texture_I_Loop.mp3';
import five05 from './samples/SP_5/DOL_Texture_M_Loop.mp3';
import five06 from './samples/SP_5/DOL_Texture_N1_Loop.mp3';
import five07 from './samples/SP_5/DOL_Texture_V_Loop.mp3';
import five08 from './samples/SP_5/DOL_Texture_Z_Loop.mp3';

// const files = require.context('./samples/SP_1', false, /\.mp3$/);
// const indexedFiles = Object.keys(files).map((key, index) => {
//   const fileName = key.replace('./', '');
//   const fileContent = files(key);
//   return { index, fileName, fileContent };
// });

const names = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'];

const SoundBankOne = [
  { soundfile: one01 },
  { soundfile: one02 },
  { soundfile: one03 },
  { soundfile: one04 },
  { soundfile: one05 },
  { soundfile: one06 },
  { soundfile: one07 },
  { soundfile: one08 }
];

const SoundBankTwo = [
  { soundfile: two01 },
  { soundfile: two02 },
  { soundfile: two03 },
  { soundfile: two04 },
  { soundfile: two05 },
  { soundfile: two06 },
  { soundfile: two07 },
  { soundfile: two08 }
];

const SoundBankThree = [
  { soundfile: three01 },
  { soundfile: three02 },
  { soundfile: three03 },
  { soundfile: three04 },
  { soundfile: three05 },
  { soundfile: three06 },
  { soundfile: three07 },
  { soundfile: three08 }
];

const SoundBankFour = [
  { soundfile: four01 },
  { soundfile: four02 },
  { soundfile: four03 },
  { soundfile: four04 },
  { soundfile: four05 },
  { soundfile: four06 },
  { soundfile: four07 },
  { soundfile: four08 }
];

const SoundBankFive = [
  { soundfile: five01 },
  { soundfile: five02 },
  { soundfile: five03 },
  { soundfile: five04 },
  { soundfile: five05 },
  { soundfile: five06 },
  { soundfile: five07 },
  { soundfile: five08 }
];

const SoundBanks = [SoundBankOne, SoundBankTwo, SoundBankThree, SoundBankFour, SoundBankFive];

SoundBanks.forEach((bank, index, array) => {
  array[index] = bank.map((texture, textureIndex) => {
    const color = Colors[textureIndex];
    const name = names[textureIndex];
    return { ...texture, color, name };
  });
});

export default SoundBanks;
